module.exports = __webpack_public_path__ + "34f6d37f83fda5ba5b364174505e7bbe.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/folder_star_gray.png
// module id = 3
// module chunks = 0 1 2 3 4